const StrangeAuth = require("strange-auth");
const CroquisTypes = require("action-types/croquis");
const Deeply = require("utils/deeply");
const CroquisMeasurements = require("utils/croquis-measurements");

const internals = {};

module.exports = (state, action) => {
    state = state || internals.initial();

    const { payload, type } = action;

    switch (type) {
        case CroquisTypes.CROQUIS_LOAD_SUCCESS:
            const nextState = Deeply(state);

            payload.croquis.forEach(element => {
                nextState.set(`all.${element.id}`, element);
            });

            return nextState.value();

        case CroquisTypes.CROQUIS_FETCH_SUCCESS:
            return Deeply(state)
                .set(`all.${payload.croquis.id}`, payload.croquis)
                .value();

        case CroquisTypes.CROQUIS_TESTER_FETCH_SUCCESS:
            return Deeply(state)
                .set(`testerData.${payload.croquis.id}`, payload.croquis)
                .value();

        case CroquisTypes.CROQUIS_SAVE_SUCCESS:
            return Deeply(state)
                .set(`all.${payload.croquis.id}`, payload.croquis)
                .value();

        case CroquisTypes.PURCHASED_LOAD_SUCCESS:
            const next = Deeply(state);

            payload.purchases.forEach(purchase => {
                next.set(`purchased.${purchase.id}`, purchase);
            });

            return next.value();

        case CroquisTypes.CROQUIS_PURCHASE_SUCCESS:
            return Deeply(state)
                .set(`purchased.${payload.purchased.id}`, payload.purchased)
                .value();

        case CroquisTypes.PURCHASE_UPGRADE_SUCCESS:
            return Deeply(state)
                .set(
                    `purchased.${payload.upgradedPurchase.id}`,
                    payload.upgradedPurchase
                )
                .value();

        case CroquisTypes.CROQUIS_DELETE_SUCCESS:
            const nextAll = { ...state.all };

            delete nextAll[payload.id];

            return {
                ...state,
                all: nextAll
            };

        case CroquisTypes.CROQUIS_MEASUREMENT_UPDATE:
            const fieldObj = CroquisMeasurements.getField(payload.field);

            if (
                !CroquisMeasurements.isValidMeasurement(
                    fieldObj,
                    payload.value,
                    payload.type
                )
            ) {
                if (!fieldObj.disableIf) {
                    break;
                }

                // Allow a null — otherwise invalid — value to pass through to state if
                // state dictates that the target field has been disabled
                const { disablingField, conditionalVal } = fieldObj.disableIf;
                const condReducerKey =
                    CroquisMeasurements.getField(disablingField).reducer ||
                    disablingField;
                let actualVal;
                if (condReducerKey.indexOf(".") !== -1) {
                    const paths = condReducerKey.split(".");
                    // reacher stolen from strange-forms
                    actualVal = paths.reduce((lastObj, prop) => {
                        if (typeof lastObj !== "object" || lastObj === null) {
                            return undefined;
                        }

                        return lastObj[prop];
                    }, state.all[payload.id].measurements);
                } else {
                    actualVal =
                        state.all[payload.id].measurements[condReducerKey];
                }

                if (actualVal !== conditionalVal) {
                    break;
                }
            }

            const measurement =
                payload.type === "number" || payload.type === "range"
                    ? parseFloat(payload.value)
                    : payload.type === "select" && payload.value === "clear"
                    ? ""
                    : payload.value;
            // This second check is part of a hack to allow selecting an option from a select menu without setting a value in
            // state (i.e. a "None" selection, or reset)
            // See components/BodyModelForm and utils/croquis-measurements for the other parts of the solution

            const reducerKey = fieldObj.reducer || payload.field;

            return Deeply(state)
                .set(
                    `all.${payload.id}.measurements.${reducerKey}`,
                    measurement
                )
                .value();

        case CroquisTypes.CROQUIS_TITLE_UPDATE:
            return Deeply(state)
                .set(`all.${payload.id}.title`, payload.title)
                .value();

        case CroquisTypes.CROQUIS_CREATE_SUCCESS:
            return Deeply(state)
                .set(`all.${payload.croquis.id}`, payload.croquis)
                .set("all.new", internals.initializeCroquis())
                .value();

        case StrangeAuth.types.LOGOUT_SUCCESS:
            return internals.initial();

        case CroquisTypes.LOAD_RENDERING_OPTIONS_SUCCESS:
            return {
                ...state,
                renderingOptions: payload.renderingOptions
            };
    }

    return state;
};

internals.initializeCroquis = () => ({
    id: "new",
    title: "",
    measurements: {
        // TODO pull these from croquis-measurements util
        units: "in",
        flags: {
            omitBust: null,
            lineColor: null
        },
        ankleCircumference: null,
        armLength: null,
        bicepCircumference: null,
        bustlineTweakVertical: null,
        calfCircumference: null,
        elbowCircumference: null,
        forearmCircumference: null,
        fullBust: null,
        fullHipCircumference: null,
        height: null,
        highBust: null,
        highHipCircumference: null,
        hipCurve: null,
        inseam: null,
        neckCircumference: null,
        neckLength: null,
        outseam: null,
        shoulderWidth: null,
        thighCircumference: null,
        thighCurveQuestionnaire: null,
        underBust: null,
        waistCircumference: null,
        waistLengthBack: null,
        waistLengthFront: null,
        waistToHip: null,
        wristCircumference: null
    }
});

internals.initial = () => ({
    all: {
        new: internals.initializeCroquis()
    },
    testerData: {},
    purchased: {},
    renderingOptions: null
});



// WEBPACK FOOTER //
// ./src/reducers/croquis.js